import {
    HARDWARE_ONLY_SWITCH,
    INSURANCE_FEATURE_TILE_CONTAINER,
    TRADE_IN_PROMO_TILE_CONTAINER,
} from '../constants';

/**
 * Get insurance status from DOM
 */
export const getInsuranceFromDom = (): boolean => {
    const container = document.getElementById(INSURANCE_FEATURE_TILE_CONTAINER);
    const checkbox = container?.getElementsByTagName('input');

    return checkbox?.[0]?.checked || false;
};

/**
 * Get hardware only from DOM
 */
export const getHardwareOnlyFromDom = (): boolean => {
    const container = document.getElementById(HARDWARE_ONLY_SWITCH);
    const checkbox = container?.getElementsByTagName('input')[0];

    return checkbox?.checked || false;
};

/**
 * Get trade in eligible state from DOM
 */
export const getIsTradeInEligibleFromDom = (): boolean => {
    const container = document.getElementById(TRADE_IN_PROMO_TILE_CONTAINER);

    return !!container && container.children.length > 0;
};
